import type { FC } from "react";

import {
  SignUpModalContainer,
  SignUpModalFooter,
  ForgotPasswordContent,
} from "@unauthenticated/signupSignin/components";

const RxSignInForgotPassword: FC = () => {
  return (
    <>
      <SignUpModalContainer>
        <ForgotPasswordContent />
      </SignUpModalContainer>
      <SignUpModalFooter />
    </>
  );
};

export { RxSignInForgotPassword };
